export default "__VITE_ASSET__GUQ2W1Fs__"